var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.document)?_c('main',{class:_vm.className,attrs:{"id":"page"}},_vm._l((_vm.slices),function(slice,index){return _c(_vm.sliceToComponent(slice),{key:`${_vm.className}-${index}`,tag:"component",attrs:{"slice":slice}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }